import {createApp} from 'vue';
import {connectVue} from '../modules/configureBugsnag';
import configureGlobalComponents from '../modules/configureGlobalComponents';
import EnquireForm from '../components/global/enquire-form.vue';
import trackSocialClicks from '../helpers/trackSocialClicks';
import adverts from '../modules/adverts';

const app = createApp({
    components: {
        'enquire-form': EnquireForm,
    },
    props: {
        totalPages: {type: Number, required: true},
        targeting: {type: Array, required: true},
    },
    data() {
        return {
            currentPage: null as null | number,
        };
    },
    computed: {
        started(): boolean {
            return this.currentPage !== null;
        },
        finished(): boolean {
            return this.currentPage >= this.totalPages - 1;
        },
    },
    methods: {
        nextPage() {
            if (this.currentPage === null) {
                this.currentPage = 0;
            } else {
                this.currentPage = this.currentPage + 1;
            }
            this.setUrl();
        },
        previousPage() {
            if (this.currentPage === null) {
                return;
            }

            this.currentPage = this.currentPage - 1;
            this.setUrl();
        },
        setUrl() {
            const url = new URL(window.location.href);
            url.searchParams.set('q', this.currentPage + 1);
            window.history.pushState({page: this.currentPage}, '', url);

            const targeting = this.targeting[this.currentPage];

            if (!targeting) {
                return;
            }

            adverts.retargetAdverts({
                [AdTargetingKey.cat]: 'single-list',
                [AdTargetingKey.make]: targeting.make || '',
                [AdTargetingKey.model]: targeting.model || '',
                [AdTargetingKey.vehicleType]: targeting.isVan ? 'van' : 'car',
            } as AdTargetingConfig);

            window.scrollTo(0, 165);
            window.sendAnalyticsEvent('Conversion Tracking', 'List Interaction', 'Page - ' + this.currentPage || 'landing');
        },
        socialClick(type: string, url: string) {
            trackSocialClicks(type);
            if (type !== 'whatsapp') {
                window.open(url, 'enquire form', 'width=600, height=400');
            }
        },
    },
    mounted() {
        const url = new URL(window.location.href);

        if (url.searchParams.has('q')) {
            this.currentPage = parseInt(url.searchParams.get('q') || '') - 1;
        }

        window.onpopstate = (event) => {
            if (event.state) {
                this.currentPage = event.state.page;
            } else {
                this.currentPage = null;
            }
        };
    },
}, window.propsData);

connectVue(app);
configureGlobalComponents(app);
app.mount('#app');
